import { Button } from "@ui/components/core/Button";
import { cn } from "@ui/lib/utils";
import * as m from "motion/react-m";

export interface SampleOption {
  label: string;
  value: string;
}
export function SamplePicker({
  samples,
  onSelected,
  className,
  selectedValue,
}: {
  className?: string;
  onSelected: (sample: SampleOption) => void;
  samples: SampleOption[];
  selectedValue?: string | null;
}) {
  return (
    <m.div
      className={cn("-mx-16 flex flex-row justify-center md:-mx-32 lg:-mx-0", className)}
      initial={{ opacity: 0, filter: "blur(2px)", transform: "translateY(0.375rem)" }}
      animate={{ opacity: 1, filter: "blur(0px)", transform: "translateY(0rem)", transition: { delay: 0.25 } }}
      exit={{ opacity: 0, filter: "blur(2px)", transform: "translateY(0rem)" }}
    >
      <div className='scrollbar-none relative flex flex-row gap-8 overflow-x-auto p-2 pl-16 md:pl-32 lg:flex-wrap lg:justify-center lg:overflow-x-visible lg:pl-0'>
        {samples.map(sample => {
          const isSelected = selectedValue === sample.value;
          return (
            <m.div
              key={sample.value}
              initial={false}
              animate={{ opacity: selectedValue && !isSelected ? 0.6 : 1 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
            >
              <Button onClick={() => onSelected(sample)} size='md' variant='elevated'>
                {sample.label}
              </Button>
            </m.div>
          );
        })}
      </div>
    </m.div>
  );
}
